import Vue from 'vue'
import dayjs from '@/helpers/dayjs'

Vue.filter('yearTh', (val) => {
  let christianYear = dayjs(val * 1000).format('YYYY')
  let buddhishYear = (parseInt(christianYear) + 543).toString()
  return dayjs(val)
    .format(buddhishYear)
    .replace(christianYear, buddhishYear)
})

Vue.filter('fullDataTh', (val) => {
  try {
    return dayjs(val).format('DD MMMM BBBB')
  } catch (e) {
    return val
  }
})
